if (!customElements.get('product-form-component')) {
  const ADD_TO_CART_POPUP_ID = 'AddToCartPopupModal';

  function escapeHTML(value) {
    return `${value ?? ''}`
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function stripHTML(value) {
    const text = `${value ?? ''}`;
    return text.replace(/<[^>]*>/g, '').trim();
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return `${((Number(cents) || 0) / 100).toFixed(2)}`;
  }

  function getAddToCartPopup() {
    const existingPopup = document.getElementById(ADD_TO_CART_POPUP_ID);
    if (existingPopup) return existingPopup;

    const popup = document.createElement('div');
    popup.id = ADD_TO_CART_POPUP_ID;
    popup.className = 'add-to-cart-popup';
    popup.setAttribute('hidden', '');
    popup.innerHTML = `
      <div class="add-to-cart-popup__overlay" data-popup-close></div>
      <div class="add-to-cart-popup__dialog" role="dialog" aria-modal="true" aria-label="Added to cart">
        <button class="add-to-cart-popup__close" type="button" data-popup-close aria-label="Close">&times;</button>
        <div class="add-to-cart-popup__product">
          <img class="add-to-cart-popup__image" src="" alt="" />
          <div class="add-to-cart-popup__info">
            <div class="add-to-cart-popup__title"></div>
            <div class="add-to-cart-popup__variant"></div>
            <div class="add-to-cart-popup__message"></div>
            <div class="add-to-cart-popup__actions">
              <button class="add-to-cart-popup__btn add-to-cart-popup__btn--outline" type="button" data-popup-close>CONTINUE SHOPPING</button>
              <a class="add-to-cart-popup__btn add-to-cart-popup__btn--outline" href="${window.routes?.cart_url || '/cart'}">VIEW CART</a>
              <a class="add-to-cart-popup__btn add-to-cart-popup__btn--solid" href="${window.routes?.root || ''}/checkout">PROCEED TO CHECKOUT</a>
            </div>
          </div>
        </div>
      </div>
    `;

    const style = document.createElement('style');
    style.textContent = `
      .add-to-cart-popup[hidden] { display: none !important; }
      .add-to-cart-popup { position: fixed; inset: 0; z-index: 999; display: grid; place-items: center; }
      .add-to-cart-popup__overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.45); }
      .add-to-cart-popup__dialog { padding: 20px;position: relative; width: min(92vw, 600px); padding: 26px 30px 30px; max-height: 90vh; overflow: auto; }
      .add-to-cart-popup__close { position: absolute; top: 4px; right: 10px; width: 34px; height: 34px; border: 0; background: #111; color: #fff; font-size: 24px; cursor: pointer; line-height: 1; display: grid; place-items: center; }
      .add-to-cart-popup__product { padding: 20px;background: #fff; display: flex; gap: 22px; margin-bottom: 26px; align-items: flex-start; }
      .add-to-cart-popup__image { width: 128px; height: 128px; object-fit: cover; background: #f4f4f4; }
      .add-to-cart-popup__title { font-size: 14px; line-height: 1.18; color: #202020; margin-bottom: 10px; letter-spacing: 0.01em; }
      .add-to-cart-popup__variant { font-size: 14px; color: #252525; margin-bottom: 10px; line-height: 1.2; }
      .add-to-cart-popup__message { font-size: 22px; color: #8f8f8f; line-height: 1.2; }
      .add-to-cart-popup__actions { display: grid; gap: 10px;margin-top: 10px; }
      .add-to-cart-popup__btn { display: flex; justify-content: center; align-items: center; padding: 15px; text-decoration: none; font-size: 14px; font-weight: 700; letter-spacing: 0.03em; text-transform: uppercase; cursor: pointer; line-height: 1; }
      .add-to-cart-popup__btn--outline { border: 1px solid #9b9b9b; color: #222; background: #fff; }
      .add-to-cart-popup__btn--solid { border: 0; color: #fff; background: #f05448; }
      @media (max-width: 767px) {
        .add-to-cart-popup__dialog { padding: 20px;  width: min(100vw, 560px); }
        .add-to-cart-popup__close { top: 8px; right: 8px; width: 30px; height: 30px; font-size: 20px; }
        .add-to-cart-popup__image { width: 84px; height: 84px; }
        .add-to-cart-popup__title, .add-to-cart-popup__message { font-size: 14px; }
        .add-to-cart-popup__variant { font-size: 14px; }
        .add-to-cart-popup__btn { font-size: 12px; padding: 10px;}
        .add-to-cart-popup__product {
    padding: 20px;
}
      }
    `;

    popup.querySelectorAll('[data-popup-close]').forEach((node) => {
      node.addEventListener('click', () => popup.setAttribute('hidden', ''));
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) popup.setAttribute('hidden', '');
    });

    document.head.appendChild(style);
    document.body.appendChild(popup);
    return popup;
  }

  function showAddToCartPopup(item) {
    const popup = getAddToCartPopup();
    const imageEl = popup.querySelector('.add-to-cart-popup__image');
    const titleEl = popup.querySelector('.add-to-cart-popup__title');
    const variantEl = popup.querySelector('.add-to-cart-popup__variant');
    const messageEl = popup.querySelector('.add-to-cart-popup__message');

    const itemTitle = item?.product_title || item?.title || '';
    const variantTitle = item?.variant_title && item.variant_title !== 'Default Title' ? stripHTML(item.variant_title) : '';
    const price = typeof item?.final_price === 'number' ? formatMoney(item.final_price) : '';
    const imageSrc = item?.image || item?.featured_image?.url || '';

    imageEl.src = imageSrc;
    imageEl.alt = escapeHTML(itemTitle);
    imageEl.style.display = imageSrc ? '' : 'none';
    titleEl.textContent = itemTitle;
    variantEl.textContent = [variantTitle].filter(Boolean).join(' / ');
    messageEl.textContent = 'is added to your shopping cart.';

    popup.removeAttribute('hidden');
  }

  customElements.define(
    'product-form-component',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.form?.querySelector('.add-to-cart-button');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
        this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
        this.buyItNowButton = this.form?.querySelector('.shopify-payment-button');

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.initAgreeCondition();

        // Sync error messages to sticky add-to-cart error area (same section)
        this.setupErrorSync();
      }

      setupErrorSync() {
        try {
          const productInfo = this.closest('product-info');
          const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
          if (!sectionId) return;

          const stickyATC = document.querySelector(`sticky-atc[data-sticky-section-id="${sectionId}"]`);
          if (!stickyATC) return;

          const mainErrorWrapper = this.querySelector('.product-form__error-message-wrapper');
          const stickyErrorWrapper = stickyATC.querySelector('.product-form__error-message-wrapper');
          if (!mainErrorWrapper || !stickyErrorWrapper) return;

          const syncFromMain = () => {
            const isVisible = !mainErrorWrapper.hasAttribute('hidden');
            const errorMessage = mainErrorWrapper.querySelector('.product-form__error-message')?.textContent;
            stickyErrorWrapper.toggleAttribute('hidden', !isVisible || !errorMessage);
            if (isVisible && errorMessage) {
              const stickyErrorMessage = stickyErrorWrapper.querySelector('.product-form__error-message');
              if (stickyErrorMessage) stickyErrorMessage.textContent = errorMessage;
            }
          };

          // Initial sync
          syncFromMain();

          // Observe changes on main error wrapper
          this._errorObserver = new MutationObserver(syncFromMain);
          this._errorObserver.observe(mainErrorWrapper, {
            attributes: true,
            attributeFilter: ['hidden'],
            childList: true,
            subtree: true,
          });

          // Also listen to cartError pub/sub to copy message
          this.cartErrorUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, () => {
            syncFromMain();
          });
        } catch (e) {
          // silent
        }
      }

      initAgreeCondition() {
        if (!this.checkbox || !this.buyItNowButton) return;

        this.buyItNowButton.classList.add('disabled');

        this.checkbox.addEventListener('change', () => {
          this.buyItNowButton.classList.toggle('disabled', !this.checkbox.checked);
        });

        this.form.addEventListener('submit', (e) => {
          if (!this.checkbox.checked) {
            e.preventDefault();
          }
        });
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');

        // Also reflect loading state on the sticky add-to-cart button (if present)
        const productInfo = this.closest('product-info');
        const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
        const stickyAddButton = sectionId
          ? document.getElementById(`StickyCart-ProductSubmitButton-${sectionId}`)
          : undefined;
        const stickyLoadingSpinner = stickyAddButton?.querySelector('.loading__spinner');
        if (stickyAddButton && stickyLoadingSpinner) {
          stickyAddButton.classList.add('loading');
          stickyLoadingSpinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const properties = document.querySelectorAll('.product-form__input [name^="properties"]')

        properties.forEach(property => {
          if (property.type === 'file') {
            if (!property.files || property.files.length === 0 || !property.files[0]) return;
            formData.append(property.name, property.files[0]);
            return;
          }

          if (property.value == null || property.value === '') return;
          formData.append(property.name, property.value);
        })

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = `${window.routes?.cart_url}`;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form-component',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => {
                  if (this.cart && typeof this.cart.renderContents === 'function') {
                    this.cart.renderContents(response, { openDrawer: false });
                    showAddToCartPopup(response);
                  }
                });
              },{ once: true });
              quickAddModal.hide(true);
            } else {
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response, { openDrawer: false });
                showAddToCartPopup(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.submitButton.querySelector('.loading__spinner')?.classList.add('hidden');

            // Clear loading state on the sticky add-to-cart button (if present)
            const productInfo = this.closest('product-info');
            const sectionId = productInfo?.dataset.section || productInfo?.dataset.originalSection;
            const stickyAddButton = sectionId
              ? document.getElementById(`StickyCart-ProductSubmitButton-${sectionId}`)
              : undefined;
            const stickyLoadingSpinner = stickyAddButton?.querySelector('.loading__spinner');
            if (stickyAddButton && stickyLoadingSpinner) {
              stickyAddButton.classList.remove('loading');
              stickyLoadingSpinner.classList.add('hidden');
            }
          });
      }

      disconnectedCallback() {
        try {
          this.cartErrorUnsubscriber?.();
          this._errorObserver?.disconnect();
        } catch (e) {
          // silent
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
